import "./styles/Recuperacion.scss"
// logo Ygia
import logo from "../logo.svg";

import imagenLogin from "../Img/login/imagen-login.png"

// importar componente modal
import React from 'react'
import { UseModal } from "../hooks/UseModal";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader } from "../componentes/GeneralComponents/Loader";
import { sendRecoveryCodeToEmail_request, resendCode_request, changePassword_request } from "../services/login_services";
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import InputAntd from "../componentes/GeneralComponents/InputAntd";
import ButtonAntd from "../componentes/GeneralComponents/ButtonAntd";
import { ContenedorBotonCentrado, ContenedorBotonDerecha } from "../componentes/GeneralComponents/Formularios";
import ModalCodigo from "../componentes/GeneralComponents/ModalDetalle";
import ModalPassword from "../componentes/GeneralComponents/ModalDetalle";
import LoaderModals from "../componentes/GeneralComponents/Loader_modals";
import SelectAntd from "../componentes/GeneralComponents/SelectAntd";
import Campos from "../componentes/GeneralComponents/campos";
import { Button, Col, ConfigProvider, Form, Input, Modal, Row } from "antd";
import { Content } from "antd/es/layout/layout";
import { CircularProgress } from "@mui/material";


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function RecuperacionNuevo() {

  const styleDet = {
    minHeight: "30vh",
    maxHeight: "90vh",
    minWidth: "56vh",
    maxWidth: "90vh",
  };

  const navigate = useNavigate();

  // ******* USE STATES *******
  const [isopenModalCodigo, openModalCodigo, closeModalCodigo] = UseModal(false);
  const [isopenModalPassword, openModalPassword, closeModalPassword] = UseModal(false);
  // validar correo
  const [validoCorreo, setvalidoCorreo] = useState(false);
  // const [correo, setcorreo] = useState('');
  const [Correo, setCorreo] = useState("");
  const [TipoUsuario, setTipoUsuario] = useState(null);

  // validar codigo
  const [validoCodigo, setvalidoCodigo] = useState(false);
  const [Codigo, setCodigo] = useState("");
  // Declaracion de HookModal && useModal
  const [CloseModalRecu] = UseModal(false);

  //Declaracion de inputs
  const [Password, setPassword] = useState("");
  const [Password2, setPassword2] = useState("");

  const [TextoMensajePassword, setTextoMensajePassword] = useState("");
  const [TextoMensajePassword2, setTextoMensajePassword2] = useState("");
  // MANEJA DE MENSAJES
  const [open, setOpen] = useState(false);
  const [typeMessage, setTypeMessage] = useState("");
  const [message, setMessage] = useState("");

  const [loader, setLoader] = useState(false);
  const [LoaderModal, setLoaderModal] = useState(false);

  const [MensajeCorreo, setMensajeCorreo] = useState("true");
  const [MensajeTipoUsuario, setMensajeTipoUsuario] = useState("true");
  const [MensajeCodigo, setMensajeCodigo] = useState("true");
  const [MensajePassword, setMensajePassword] = useState("true");
  const [MensajePassword2, setMensajePassword2] = useState("true");

  // ****** VALIDACIONES *******

  const expresiones = {
    password: /^[a-zA-Z0-9]{8,}$/, // Letras y numeros.
    correo: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
    codigo: /^\d{1,4}$/, // 7 a 14 numeros.
  };

  const validarPassword2 = (pass) => {
    if (Password.length > 0) {
      if (Password !== pass) {
        setTextoMensajePassword2("Las contraseñas no coinciden");
        setMensajePassword2("false");
      } else {
        setMensajePassword2("true");
      }
    }
  };

  async function recoveryPassword() {
    setLoader(true);
    if (!!Correo && MensajeCorreo === "true" && !!TipoUsuario) {
      let data = new FormData();
      data.append("email", Correo);
      data.append("Tipo", TipoUsuario);
      let response = await sendRecoveryCodeToEmail_request(data);
      if (response.ok) {
        setOpen(true);
        setTypeMessage("success");
        setMessage("Código enviado");
        openModalCodigo(true);
      } else {
        setOpen(true);
        setTypeMessage("error");
        setMessage(response.mensaje);
      }
    } else {
      if (!!!Correo) {
        setMensajeCorreo("false");
      }

      if (!!!TipoUsuario) {
        setMensajeTipoUsuario("false");
      }

      setOpen(true);
      setTypeMessage("warning");
      setMessage("Faltan campos por llenar");
    }
    setLoader(false);

  }

  async function ResendCode() {
    let data = new FormData();
    data.append("email", Correo);
    let response = await sendRecoveryCodeToEmail_request(data);
    if (response.ok) {
      setOpen(true);
      setTypeMessage("success");
      setMessage("Código enviado");
    } else {
      setOpen(true);
      setTypeMessage("error");
      setMessage(response.mensaje);
    }
  }

  async function sendCodeToValidation() {
    setLoaderModal(true);
    if (!!Codigo.trim()) {
      let response = await resendCode_request(Codigo);
      if (response.ok) {
        setOpen(true);
        setTypeMessage("success");
        setMessage("Código verificado");
        closeModalCodigo(true);
        openModalPassword(true);
      } else {
        setOpen(true);
        setTypeMessage("error");
        setMessage(response.mensaje);
      }

    } else {
      setOpen(true);
      setTypeMessage("warning");
      setMessage("Debe escribir un código");
    }
    setLoaderModal(false);
  }

  async function changePassword() {
    setLoaderModal(true);
    if (!!Password && MensajePassword === "true" && !!Password2 && MensajePassword2 === "true") {
      let data = new FormData();
      data.append("email", Correo);
      data.append("password", Password);
      data.append("token", Codigo);

      let response = await changePassword_request(data);
      if (response.ok) {
        setOpen(true);
        setTypeMessage("success");
        setMessage("Contraseña cambiada");
        navigate("/login", { replace: true });
      } else {
        setOpen(true);
        setTypeMessage("error");
        setMessage(response.mensaje);
      }
    } else {
      if (!!!Password) {
        setTextoMensajePassword("Debe escribir una contraeña");
        setMensajePassword("false");
      }
      if (!!!Password2) {
        setTextoMensajePassword2("Debe confirmar la contraseña");
        setMensajePassword2("false");
      }
      setOpen(true);
      setTypeMessage("warning");
      setMessage("Faltan campos por completar");
    }
    setLoaderModal(false);
  }

  return (
    <Stack>
      <Content
        className="site-layout"
        style={{
          // padding: "0 3%",
          // height: "100vh",
          width: "100%",
          overflow: "initial",
        }}
      >
        <Row style={{ height: "100vh" }}>
          <Col className="colLeft">
            <Form
              onSubmitCapture={() => {
                recoveryPassword();
              }}
              layout="vertical"
              style={{ padding: "5%" }}
            >
              <img src={logo} alt="" className="lgo" />

              <ConfigProvider theme={{
                token: { borderRadius: 15 }
              }}>
                <SelectAntd
                  label="Tipo de usuario:"
                  requiredICon={true}
                  vacio={false}
                  value={TipoUsuario}
                  style={{ width: "100%", marginBottom: "1%" }}
                  placeholder="Selecciona un tipo"
                  options={[{ value: "1", label: "Médico" }, { value: "4", label: "Asistente" }]}
                  setStateValue={setTipoUsuario}
                  setStateError={setMensajeTipoUsuario}
                  valueError={MensajeTipoUsuario}
                  textError={["Debe seleccionar un tipo"]}
                />
              </ConfigProvider>
              <InputAntd
                label="Correo electrónico:"
                requiredICon={true}
                style={{ width: "100%", marginBottom: "1%", color: "black", borderRadius: "15px" }}
                className="inputblue"
                value={Correo}
                type="email"
                setStateValue={setCorreo}
                placeholder="usuario@ejemplo.com"
                valueError={MensajeCorreo}
                setStateError={setMensajeCorreo}
                textError={["Este campo es obligatorio", "Formato correo erroneo", ""]}
                vacio={false}
                expresionRegular={expresiones.correo}
              />
              <br />
              <h5 style={{ marginBottom: "20px" }}>
                <span>Regresar a</span>
                <Link replace={true} to="/login"><span style={{ color: "#148f9f" }}>Iniciar sesión</span></Link>
              </h5>
              <div style={{ display: "flex", justifyContent: "end", width: "100%" }}>
                {loader ? (
                  <CircularProgress size={40} sx={{ color: "#148f9f" }} />
                ) : (
                  <Button className="buttonLogin" htmlType="submit" type="button">Recuperar</Button>
                )}

              </div>
            </Form>
          </Col>
          <Col className="colRight">
            <Stack style={{ width: "100%", height: "100%" }}>
              <img src={imagenLogin} alt="" style={{ width: "100%", height: "100%" }} />
              <div className="colorBlurRegistro">
                <div style={{ width: "50%" }}>
                  <h2 style={{ color: "#ffffff", marginLeft: "5%", fontSize: "50px" }}>Recuperación de contraseña</h2>
                </div>
              </div>
            </Stack>
          </Col>
        </Row>
      </Content>

      <Modal
        centered
        open={isopenModalCodigo}
        closable={false}
        footer={[
          <ButtonAntd
            style={{ width: "30%" }}
            tipo={2}
            onClick={() => {
              if (!LoaderModal) {
                ResendCode();
              }
            }}
          >
            Reenviar
          </ButtonAntd>,
          <ButtonAntd
            style={{ width: "30%" }}
            onClick={() => {
              sendCodeToValidation();
            }}
          >

            {!LoaderModal ? (<>Verificar</>) : (<CircularProgress size={15} sx={{ color: "#ffffff" }} />)}
          </ButtonAntd>
        ]}
      >
        <div style={{ padding: "1%" }}>
          <div style={{ textAlign: "center" }}>
            <img style={{ width: "25%", marginBottom: "3%" }} src={logo} alt="" className="lgo" />
            <form action="">
              <p>Se te ha enviado un correo a:</p>
              <b>{Correo}</b>

              <InputAntd
                style={{ width: "100%", marginBottom: "1%" }}
                className="inputblue"
                type="text"
                id="codigo"
                value={Codigo}
                setStateValue={setCodigo}
                label="Código:"
                placeholder="Escribe tu código"
                valueError={MensajeCodigo}
                setStateError={setMensajeCodigo}
                textError={["Debe escribir un código", "Solo puede contener numeros", "Debe contener 4 digitos"]}
                vacio={false}
                expresionRegular={expresiones.codigo}
                maxLength={4}
              />
            </form>
          </div>
        </div>
      </Modal>

      <Modal
        centered
        open={isopenModalPassword}
        closable={false}
        footer={[
          <ButtonAntd
            style={{ width: "40%" }}
            onClick={() => {
              changePassword();
            }}
          >
            {!LoaderModal ? (<>Cambiar contraseña</>) : (<CircularProgress size={15} sx={{ color: "#ffffff" }} />)}

          </ButtonAntd>

        ]}
      >
        <div style={{ padding: "1%" }}>
          <form action="">
            <b>Nueva contraseña</b>
            <Campos
              label="Contraseña:"
              requiredICon={true}
              valueError={MensajePassword}
              textError={TextoMensajePassword}
              vacio={false}
              styleDiv={{ marginBottom: "1%" }}
            >
              <Input.Password
                className="inputblue"
                style={{ width: "100%", marginBottom: "1%", padding: "0 10px" }}
                placeholder="Escribe una contraseña"
                status={MensajePassword === "false" && "error"}
                onChange={(e) => {
                  if (expresiones.password.test(e.target.value)) {
                    setPassword(e.target.value);
                    if (e.target.value.length < 8) {
                      setTextoMensajePassword("Minimo 8 caracteres")
                      setMensajePassword("false");
                    } else {
                      setTextoMensajePassword("");
                      setMensajePassword("true");
                    }
                  } else {
                    if (!!e.target.value) {
                      if (e.target.value.length < 8) {
                        setTextoMensajePassword("Minimo 8 caracteres");
                        setMensajePassword("false");
                      } else {
                        setTextoMensajePassword("Solo se permiten letras y numeros");
                        setMensajePassword("false");
                      }
                    } else {
                      setTextoMensajePassword("Este campo es obligatorio");
                      setMensajePassword("false");
                    }
                  }
                }}
                maxLength={16}
              />
            </Campos>

            <Campos
              label="Repetir contraseña:"
              requiredICon={true}
              valueError={MensajePassword2}
              textError={TextoMensajePassword2}
              vacio={false}
              styleDiv={{ marginBottom: "1%" }}
            >
              <Input.Password
                className="inputblue"
                style={{ width: "100%", marginBottom: "1%", padding: "0 10px" }}
                placeholder="Repita su contraseña"
                status={MensajePassword2 === "false" && "error"}
                onChange={(e) => {
                  if (expresiones.password.test(e.target.value)) {
                    setPassword2(e.target.value);
                    if (e.target.value.length < 8) {
                      setTextoMensajePassword2("Minimo 8 caracteres")
                      setMensajePassword2("false");
                    } else {
                      validarPassword2(e.target.value);
                      // setTextoMensajePassword2("");
                      // setMensajePassword2("true");
                    }
                  } else {
                    if (!!e.target.value) {
                      if (e.target.value.length < 8) {
                        setTextoMensajePassword2("Minimo 8 caracteres");
                        setMensajePassword2("false");
                      } else {
                        setTextoMensajePassword2("Solo se permiten letras y numeros");
                        setMensajePassword2("false");
                      }
                    } else {
                      setTextoMensajePassword2("Este campo es obligatorio");
                      setMensajePassword2("false");
                    }
                  }
                }}
                maxLength={16}
              />
            </Campos>
          </form>
        </div>
      </Modal>

      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
      >
        <Alert onClose={() => setOpen(false)} severity={typeMessage} sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    </Stack >

  )
}

export default RecuperacionNuevo;